export default __webpack_public_path__ + "static/media/fileIcon.112e8a63.svg";